import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SkeletonBuilderComponent } from "./skeleton-builder/skeleton-builder.component";
import { SkeletonLoaderComponent } from "./skeleton-loader/skeleton-loader.component";
import { TimesDirective } from "./skeleton-builder/times.directive";

@NgModule({
  imports: [CommonModule],
  declarations: [
    SkeletonLoaderComponent,
    SkeletonBuilderComponent,
    TimesDirective
  ],
  exports: [SkeletonLoaderComponent, SkeletonBuilderComponent]
})
export class SkeletonModule {}
